"use client";

import { Bone, Button, Skeleton } from "@pamperedchef/design-system";
import * as styles from "./stubs.module.scss";

/** STUB product card — DS skeleton image + Add to Cart placeholder only. */
export function PlpProductCard(): JSX.Element {
	return (
		<article className={styles["stackSm"]} data-component="PlpProductCard">
			<Skeleton>
				<Bone width="100%" height="200px" borderRadius="8px" />
			</Skeleton>
			<Button kind="primary" size="sm">
				Add to Cart
			</Button>
		</article>
	);
}
